import { FEATURES } from '@constants/Text'
import { isCliente } from '@modules/financial-planning/utils/client-permissions'

/**
 * Regra de acesso à tela de Conexões do Atendimento, em UM lugar.
 *
 * Ela é consumida por DUAS fontes que precisam concordar: o guard de rota
 * (`settings/routes.js`) e o menu de ações da conexão (`conexao-actions-menu.vue`).
 * Menu mais frouxo que o guard vira link para 404; mais apertado, vira funcionalidade
 * inalcançável. Duplicar a condição nos dois consumidores é exatamente como as cinco
 * grafias da Base de Ativos nasceram — por isso a regra mora aqui, e eles compõem.
 *
 * ★ A FLAG é lida ANTES do papel do usuário, de propósito. Com o papel num early return,
 * o Vue 2 não registra `$access` como dependência do computed que chama (a leitura fica
 * inalcançável naquele caminho) e o valor congela no primeiro render — a flag pode chegar
 * depois do mount e a tela não reage.
 *
 * ★ O CLIENTE FINAL é reprovado explicitamente. As rotas de Configurações não declaram
 * `meta.permission`, então o guard global (`src/router/index.js`) cai no `else { next() }`
 * e a tela renderiza para o perfil errado: sem esta linha, uma sessão `IS_CLIENTE` num
 * escritório com a feature de Atendimento ligada alcançaria a tela por URL. Precedente do
 * gate de perfil: `financial-planning/utils/client-permissions`.
 *
 * O papel de GESTOR não entra na conta: gestor e não-gestor recebem a mesma resposta. É
 * essa ausência que faz a liberação do profissional ser propriedade do arquivo, e não uma
 * promessa que depende do `if` certo em cada consumidor.
 *
 * @param {object} user usuário da sessão (`$currentUser()` / `ctx.user`)
 * @param {object} show mapa de features do escritório (`$access` / `ctx.show`)
 * @returns {boolean}
 */
export const podeAcessarConexoesAtendimento = (user, show) => {
  const temFlag = Boolean((show || {})[FEATURES.ATENDIMENTO])
  if (!user) return false
  if (isCliente(user)) return false
  return temFlag
}
